import {
  TransactionItemState,
  useTransactionItemDeleteNotification,
} from '@/context/services/transaction_items/TransactionItem.service';
import {
  TransactionItemsTableView,
  type TransactionItemsViewTableProps,
} from '@/features/transaction_items/List/Table/Table';
import { FC, memo } from 'react';
import { useLocation } from 'react-router-dom';

function isTransactionItemState(state: unknown): state is TransactionItemState {
  return (
    typeof state === 'object' &&
    state !== null &&
    'transaction_item_deleted' in state
  );
}

export type Props = {
  onOrderChange: (isOrderChanged: boolean) => void;
  isOrderChanged: boolean;
  confirmCancelReordering: () => Promise<boolean>;
} & TransactionItemsViewTableProps;

export const TransactionItemsList: FC<Props> = memo(
  ({
    isFlexibleValidationEnabled,
    tableBodyHeight,
    isReorderingMode,
    enterReorderingMode,
    exitReorderingMode,
    showFullScreenLoading,
    isFullScreenLoading,
    onOrderChange,
    isOrderChanged,
    confirmCancelReordering,
    setIsDrawerIsOpen,
    notificationErrorVisible,
    notificationErrorContextHolder,
    onClearNotificationErrorMessage,
  }) => {
    const location = useLocation();
    const state = isTransactionItemState(location.state)
      ? location.state
      : null;

    useTransactionItemDeleteNotification(state);

    return (
      <TransactionItemsTableView
        isFlexibleValidationEnabled={isFlexibleValidationEnabled}
        tableBodyHeight={tableBodyHeight}
        isReorderingMode={isReorderingMode}
        enterReorderingMode={enterReorderingMode}
        exitReorderingMode={exitReorderingMode}
        showFullScreenLoading={showFullScreenLoading}
        isFullScreenLoading={isFullScreenLoading}
        onOrderChange={onOrderChange}
        isOrderChanged={isOrderChanged}
        confirmCancelReordering={confirmCancelReordering}
        setIsDrawerIsOpen={setIsDrawerIsOpen}
        notificationErrorContextHolder={notificationErrorContextHolder}
        notificationErrorVisible={notificationErrorVisible}
        onClearNotificationErrorMessage={onClearNotificationErrorMessage}
      />
    );
  }
);
TransactionItemsList.displayName = 'TransactionItemsList';
